import { ActiveComponentEnum } from "enums/enums";
import React, { ReactElement } from "react";
import { OnNavigateFunction } from "types/ListAndDetailTypes";
import "./NavigationButton.css";

interface NavigationButtonProps {
  navigateTo: ActiveComponentEnum;
  text: string;
  icon?: ReactElement;
  iconLabel: string;
  onNavigate: OnNavigateFunction;
  additionalParams?: any;
  iconFirst?: boolean;
  ariaLabelText?: string;
  }

const NavigationButton: React.FC<NavigationButtonProps> = ({
  navigateTo,
  text,
  icon,
  iconLabel,
  onNavigate,
  additionalParams,
  iconFirst = false,
  ariaLabelText = ''
}) => {
  const handleOnClick = () => {
    onNavigate(navigateTo, additionalParams);
  };

  return (
    <button onClick={handleOnClick} className="link-button d-flex align-items-lg-center" aria-label={`${text} ${ariaLabelText}`}>
      <span className="text-style" role="button">{text}</span>
      <span className={`icon-style ${iconFirst && "order-first"}`} >{icon}</span>
    </button>
  );
};

export default NavigationButton;
